var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { PeekStack } from "@piiqtechnologies/ui-components";
import React from "react";
export const TableActionsContainer = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (React.createElement(PeekStack, Object.assign({}, props, { justifyContent: "end", "data-testid": "table-actions", spacing: 0.5, mr: 2, direction: "row" }), children));
};
export default TableActionsContainer;
